/* Pure offer arithmetic. Preview totals never replace Shopify's actual cart. */
(function (root, factory) {
  'use strict';
  if (typeof module === 'object' && module.exports) module.exports = factory(require('./grig-merchandising.js'));
  else root.GRIGOfferEngine = factory(root.GRIGMerch);
})(typeof window === 'undefined' ? globalThis : window, function (merch) {
  'use strict';
  var PREVIEW_THEME = '204760416596';
  function clone(value) { return value == null ? value : JSON.parse(JSON.stringify(value)); }
  function integer(value) { return typeof value === 'number' && Number.isSafeInteger(value); }
  function positive(value) { return integer(value) && value > 0; }
  function money(value) { return integer(value) && value >= 0; }
  function id(value) {
    if (typeof value !== 'number' && typeof value !== 'string') return null;
    var key = String(value);
    return /^[1-9]\d*$/.test(key) && Number.isSafeInteger(Number(key)) ? key : null;
  }
  function variantFor(line, catalog) {
    var key = id(line && (line.variant_id == null ? line.id : line.variant_id));
    var variant = key && catalog && catalog.variants && catalog.variants[key];
    return variant && id(variant.id) === key && variant.product && id(variant.product.id) ? variant : null;
  }
  function restricted(value) {
    value = value || {};
    var text = [value.tags, value.type, value.product_type, value.handle].join(' ');
    return value.selling_plan_allocation != null || value.sellingPlanAllocation != null || value.selling_plan != null || value.requires_selling_plan === true ||
      (Array.isArray(value.selling_plan_groups) && value.selling_plan_groups.length > 0) ||
      /(^|[\s,/_-])(alcohol|alcoholic|alkohol|beer|bier|wine|wein|vin|spirit|liqueur)([\s,/_-]|$)/i.test(text);
  }
  function component(value) {
    value = value || {};
    return value.parent_relationship != null || value.parentRelationship != null || value.has_components === true ||
      value.requires_components === true || (Array.isArray(value.item_components) && value.item_components.length > 0) ||
      (Array.isArray(value._grigNativeComponents) && value._grigNativeComponents.length > 0);
  }
  function single(line, catalog) {
    var variant = variantFor(line, catalog);
    return !!(variant && positive(line.quantity) && !restricted(line) && !restricted(variant) && !restricted(variant.product) &&
      !component(line) && !component(variant) && !component(variant.product) && !variant.knownBox && !variant.product.recipe &&
      !(Array.isArray(catalog.boxes) ? catalog.boxes : []).some(function (box) { return box && box.variant && id(box.variant.id) === id(variant.id); }));
  }
  function getSingleCount(cart, catalog) {
    var count = 0;
    (cart && Array.isArray(cart.items) ? cart.items : []).forEach(function (line) {
      if (single(line, catalog) && Number.isSafeInteger(count + line.quantity)) count += line.quantity;
    });
    return count;
  }
  function originalTotal(line) {
    if (line.original_line_price != null) return money(line.original_line_price) ? line.original_line_price : null;
    var price = line.original_price != null ? line.original_price : line.price;
    return money(price) && positive(line.quantity) && money(price * line.quantity) ? price * line.quantity : null;
  }
  function rowsFor(cart, catalog) {
    if (!cart || !Array.isArray(cart.items)) return null;
    var rows = [], sum = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var line = cart.items[i], variant = variantFor(line, catalog), total = originalTotal(line || {});
      if (!variant || !positive(line.quantity) || total === null || !money(sum + total)) return null;
      rows.push({key:line.key == null ? 'line:' + i : String(line.key), variantId:id(variant.id),
        quantity:line.quantity, originalLineTotal:total, eligible:single(line, catalog)});
      sum += total;
    }
    return money(cart.total_price) && money(cart.original_total_price) && cart.original_total_price === sum ? rows : null;
  }
  function progress(kind, current, target, percent, mode) {
    return {kind:kind, current:current, target:target, gap:Math.max(0, target - current),
      progress:Math.min(1, current / target), reached:current >= target, percent:percent, mode:mode};
  }
  function validPercent(value) { return positive(value) && value <= 100; }
  function regularPolicy(policy, currency) {
    var rule = policy.regular;
    return rule && rule.enabled === true && positive(rule.threshold) && validPercent(rule.percent) &&
      Array.isArray(rule.currencies) && rule.currencies.includes(currency) ? rule : null;
  }
  function bfStatus(rule, currency, now) {
    if (currency !== 'EUR') return 'unsupported-currency';
    if (!rule || rule.enabled !== true || rule.currency !== 'EUR' || !positive(rule.threshold) ||
        !validPercent(rule.basePercent) || !validPercent(rule.bonusPercent) || rule.basePercent >= rule.bonusPercent) return 'disabled';
    var zoned = /(?:Z|[+-]\d{2}:\d{2})$/;
    if (!zoned.test(rule.startsAt || '') || !zoned.test(rule.endsAt || '')) return 'invalid-schedule';
    var start = Date.parse(rule.startsAt), end = Date.parse(rule.endsAt);
    if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start || !Number.isFinite(now)) return 'invalid-schedule';
    return now < start ? 'scheduled' : now >= end ? 'ended' : 'ready';
  }
  function roundLine(total, percent) {
    // Round the resulting line total half up. This is a model, not an assertion
    // about Shopify's future per-unit or cross-line allocation algorithm.
    return Number((BigInt(total) * BigInt(100 - percent) + 50n) / 100n);
  }
  function codesCombine(cart, allowed) {
    var ok = (Array.isArray(allowed) ? allowed : []).map(function (c) { return String(c).toUpperCase(); }), found = [];
    (Array.isArray(cart.discount_codes) ? cart.discount_codes : []).forEach(function (d) { found.push(d && d.code); });
    (Array.isArray(cart.cart_level_discount_applications) ? cart.cart_level_discount_applications : []).forEach(function (a) {
      if (a && a.type === 'discount_code') found.push(a.title);
    });
    (Array.isArray(cart.items) ? cart.items : []).forEach(function (line) {
      (line && Array.isArray(line.line_level_discount_allocations) ? line.line_level_discount_allocations : []).forEach(function (a) {
        var app = a && a.discount_application;
        if (app && app.type === 'discount_code') found.push(app.title);
      });
    });
    return found.every(function (code) { return typeof code === 'string' && ok.indexOf(code.toUpperCase()) >= 0; });
  }
  function shippingState(cart, policy, projection, preview) {
    var rule = policy.shipping && policy.shipping[cart.currency];
    if (!rule || !positive(rule.threshold)) return null;
    var modeled = preview && projection.active;
    if (!modeled && (rule.verified !== true || rule.planned === true)) return null;
    // Free shipping is decided on the cart before discounts (owner, 26 Oct 2026): the GRIG build
    // checkout function grants it from the undiscounted line costs, so GRIG15 or 10 % off sachets
    // never take a cart that reached it back under.
    // Only codes known to combine with that shipping discount keep the cart on this basis; any
    // other code may block it at checkout, so the cart falls back to the total after discounts.
    var original = rule.beforeDiscounts === true && money(cart.original_total_price) && codesCombine(cart, rule.codes);
    var subtotal = modeled ? projection.total : original ? cart.original_total_price : cart.total_price;
    if (!money(subtotal)) return null;
    return Object.assign(progress('shipping', subtotal, rule.threshold, null, modeled ? 'preview' : 'native-verified'),
      {threshold:rule.threshold, subtotal:subtotal, planned:rule.planned === true,
        subtotalBasis:modeled ? 'projected_total_price' : original ? 'original_total_price' : 'total_price'});
  }
  function existingQuantities(cart) {
    var counts = {};
    (Array.isArray(cart.items) ? cart.items : []).forEach(function (line) {
      if (!line) return;
      var key = id(line.variant_id == null ? line.id : line.variant_id);
      if (key && positive(line.quantity)) counts[key] = (counts[key] || 0) + line.quantity;
    });
    return counts;
  }
  function addable(variant, quantity, existing) {
    if (!variant || !id(variant.id) || !variant.product || !id(variant.product.id) ||
        restricted(variant) || restricted(variant.product) || !positive(quantity) ||
        !positive((existing[id(variant.id)] || 0) + quantity)) return false;
    return !!(merch && merch.allowed && merch.allowed(variant, quantity, existing));
  }
  /* NATIVE MODE. Rules describe Shopify automatic discounts that already exist.
     Progress may be projected from quantities; savings only come from cart.js. */
  function handleList(value) {
    return Array.isArray(value) && value.length > 0 && value.length <= 60 && value.every(function (h) {
      return typeof h === 'string' && /^[a-z0-9][a-z0-9-]{0,99}$/.test(h);
    }) ? value : null;
  }
  function title(value) { return typeof value === 'string' && value.trim().length > 0 && value.length <= 255; }
  function sachetRule(rules) {
    var rule = rules && rules.sachets;
    return rule && rule.enabled === true && positive(rule.threshold) && rule.threshold <= 50 && validPercent(rule.percent) &&
      title(rule.title) && handleList(rule.handles) ? rule : null;
  }
  // The Black Friday dates of an enabled rule: zoned, the end after the start; otherwise null.
  function bfDates(rule) {
    if (!rule || rule.enabled !== true) return null;
    var zoned = /(?:Z|[+-]\d{2}:\d{2})$/;
    if (!zoned.test(rule.startsAt || '') || !zoned.test(rule.endsAt || '')) return null;
    var start = Date.parse(rule.startsAt), end = Date.parse(rule.endsAt);
    return Number.isFinite(start) && Number.isFinite(end) && end > start ? {start:start, end:end} : null;
  }
  // The one Black Friday schedule rule: those dates on a rule with valid tiers and titles;
  // otherwise null. The engine quotes a period only from it, and a boundary holds the cart only
  // from it, so nothing waits for a period the engine never quotes.
  function bfSchedule(rules) {
    var rule = rules && rules.bf, dates = bfDates(rule);
    if (!dates || !rule.base || !rule.bonus) return null;
    if (!validPercent(rule.base.percent) || !validPercent(rule.bonus.percent) || rule.base.percent >= rule.bonus.percent ||
        !title(rule.base.title) || !title(rule.bonus.title) || !positive(rule.bonus.threshold)) return null;
    return {start:dates.start, end:dates.end, rule:rule};
  }
  function bfRule(rules, currency, now) {
    var schedule = bfSchedule(rules);
    if (!schedule || schedule.rule.currency !== currency || !Number.isFinite(now)) return null;
    return now >= schedule.start && now < schedule.end ? schedule.rule : null;
  }
  function nativeActive(policy) { return !!(policy && policy.native && policy.native.enabled === true); }
  // The one offer-mode predicate every script shares (cart page, offer slots,
  // merchandising): 'preview' only on the private preview theme, identified by the
  // server config and by Shopify.theme alike; otherwise 'native' when the theme settings
  // enable native offers; otherwise 'plain'.
  function offerMode(config, theme) {
    if (!config || typeof config !== 'object') return 'plain';
    if (config.previewAuthorized === true && config.themeId === PREVIEW_THEME && config.themeRole === 'unpublished' &&
        !!theme && String(theme.id) === PREVIEW_THEME && theme.role === 'unpublished') return 'preview';
    return config.native && typeof config.native === 'object' && config.native.enabled === true ? 'native' : 'plain';
  }
  // The same predicate read from the page's grigOfferConfig (none, or unreadable: plain).
  function pageOfferMode(doc, theme) {
    var node = doc && doc.getElementById('grigOfferConfig');
    if (!node) return 'plain';
    try { return offerMode(JSON.parse(node.textContent), theme); } catch (_) { return 'plain'; }
  }
  // A line counts only when its variant resolves in the catalog: an unknown variant is
  // never assumed to be an eligible sachet.
  function nativeEligible(line, rule, catalog) {
    if (!line || !positive(line.quantity) || rule.handles.indexOf(String(line.handle || '')) < 0) return false;
    if (restricted(line) || component(line) || line.knownBox === true) return false;
    var variant = variantFor(line, catalog);
    return !!variant && !variant.knownBox && !variant.product.recipe;
  }
  function nativeCount(cart, rule, catalog) {
    var count = 0;
    (cart && Array.isArray(cart.items) ? cart.items : []).forEach(function (line) {
      if (nativeEligible(line, rule, catalog) && Number.isSafeInteger(count + line.quantity)) count += line.quantity;
    });
    return count;
  }
  // Applied savings come only from Shopify's own allocations, matched by exact discount title.
  function appliedSavings(cart, titles) {
    var lines = 0, order = 0;
    (cart && Array.isArray(cart.items) ? cart.items : []).forEach(function (line) {
      (Array.isArray(line.line_level_discount_allocations) ? line.line_level_discount_allocations : []).forEach(function (allocation) {
        var application = allocation && allocation.discount_application || {};
        if (titles.indexOf(application.title) >= 0 && money(allocation.amount)) lines += allocation.amount;
      });
    });
    (cart && Array.isArray(cart.cart_level_discount_applications) ? cart.cart_level_discount_applications : []).forEach(function (application) {
      if (application && titles.indexOf(application.title) >= 0 && money(application.total_allocated_amount)) order += application.total_allocated_amount;
    });
    var total = lines || order;
    return money(total) && (!money(cart.original_total_price) || total <= cart.original_total_price) ? total : 0;
  }
  // Black Friday evidence. Titles compare as Shopify and the theme setting may each write them
  // (outer spaces and case aside); any discount under a Black Friday title, of any amount, line
  // or order level, shows that Shopify runs Black Friday for this cart.
  function normTitle(value) { return typeof value === 'string' ? value.trim().toLowerCase() : ''; }
  function underTitles(application, titles) { return !!application && titles.indexOf(normTitle(application.title)) >= 0; }
  function bfTitles(rule) { return rule && rule.base && rule.bonus ? [rule.base.title, rule.bonus.title].map(normTitle).filter(Boolean) : []; }
  function carriesTitles(cart, titles) {
    if (!titles.length) return false;
    return (Array.isArray(cart.items) ? cart.items : []).some(function (line) {
      return !!line && Array.isArray(line.line_level_discount_allocations) && line.line_level_discount_allocations.some(function (allocation) {
        return !!allocation && underTitles(allocation.discount_application, titles);
      });
    }) || (Array.isArray(cart.cart_level_discount_applications) ? cart.cart_level_discount_applications : []).some(function (application) {
      return underTitles(application, titles);
    });
  }
  // The undiscounted subtotal of the lines Shopify gives Black Friday: each line allocated
  // under its titles, or every line under an order level application of them. A selection's
  // model lines carry no allocation and never count.
  function bfCovered(cart, titles) {
    var real = (Array.isArray(cart.items) ? cart.items : []).filter(function (line) { return !!line && line.grigModel !== true; });
    var order = (Array.isArray(cart.cart_level_discount_applications) ? cart.cart_level_discount_applications : []).some(function (application) {
      return underTitles(application, titles);
    });
    var sum = 0;
    for (var i = 0; i < real.length; i++) {
      var line = real[i], covered = order || (Array.isArray(line.line_level_discount_allocations) && line.line_level_discount_allocations.some(function (allocation) {
        return !!allocation && underTitles(allocation.discount_application, titles);
      }));
      if (!covered) continue;
      var total = originalTotal(line);
      if (total === null || !money(sum + total)) return null;
      sum += total;
    }
    return sum;
  }
  // Shopify is the truth: an allocation under the rule's exact title means the rule
  // is met, even when the theme's handle list and the admin discount disagree.
  function confirmReached(goal) {
    goal.reached = true; goal.gap = 0; goal.progress = 1; goal.current = Math.max(goal.current, goal.target);
    goal.confirmedByShopify = true;
  }
  // Codes the shopper entered (cart.js discount_codes), applied or waiting for a minimum.
  // Native rules are automatic discounts and never appear there, so every code makes a
  // projection null and keeps the sachet percentage from being promised.
  function hasCodes(cart) {
    return cart.discount_codes != null && !(Array.isArray(cart.discount_codes) && cart.discount_codes.length === 0);
  }
  // A code the owner set to combine with the sachet rule (combinableCodes, GRIG15 on the live
  // store) does not take the promise away; any other code still does.
  function foreignCodes(cart, rules) {
    if (!hasCodes(cart)) return false;
    if (!Array.isArray(cart.discount_codes)) return true;
    var ok = (rules && Array.isArray(rules.combinableCodes) ? rules.combinableCodes : []).map(function (c) { return String(c).toUpperCase(); });
    return !cart.discount_codes.every(function (d) { return d && typeof d.code === 'string' && ok.indexOf(d.code.toUpperCase()) >= 0; });
  }
  function nativeGoal(cart, catalog, policy, now) {
    var rules = policy.native, projected = cart.__grigProjectionOnly === true, goal;
    var bf = bfRule(rules, cart.currency, now);
    if (bf) {
      if (!money(cart.original_total_price)) return null;
      // Progress toward the top tier counts only the lines Shopify gives Black Friday.
      var covered = bfCovered(cart, bfTitles(bf));
      if (covered === null) return null;
      goal = progress('bf', covered, bf.bonus.threshold, bf.bonus.percent, 'native');
      goal.basePercent = bf.base.percent;
      goal.appliedSavings = projected ? null : appliedSavings(cart, [bf.base.title, bf.bonus.title]);
      goal.titles = [bf.base.title, bf.bonus.title];
      // Progress runs on the total; the top tier itself is confirmed only when Shopify
      // allocates it under its exact title (a code instead, or a paused discount, is not).
      goal.tierConfirmed = !projected && appliedSavings(cart, [bf.bonus.title]) > 0;
      if (goal.tierConfirmed && !goal.reached) confirmReached(goal);
      // The bonus tier has no promisable equivalent of its own, so its gap may be promised
      // only while Shopify shows Black Friday applies: a saving it allocates under a Black
      // Friday title. Lines without one prove it does not (a code preferred, a paused rule),
      // and a cart without lines (or only a selection's model lines, which carry none) proves
      // nothing either way: then Black Friday is only named (noEvidence). A code in the cart
      // blocks the promise as with the sachet rule.
      var real = (Array.isArray(cart.items) ? cart.items : []).filter(function (line) { return !(line && line.grigModel === true); });
      goal.promisable = !hasCodes(cart) && appliedSavings(cart, goal.titles) > 0;
      goal.noEvidence = !real.length;
      return goal;
    }
    var rule = sachetRule(rules);
    if (!rule) return null;
    goal = progress('sachets', nativeCount(cart, rule, catalog), rule.threshold, rule.percent, 'native');
    goal.appliedSavings = projected ? null : appliedSavings(cart, [rule.title]);
    goal.titles = [rule.title];
    // The percentage may be promised (a gap, a selection reaching it, a top-up) only
    // without a code in the cart: Shopify may not combine a code with the automatic rule.
    // Nor while Shopify runs Black Friday for this cart (a discount under its titles, also
    // outside the theme's dates): no sachet tier is then promised anywhere (bfRunning).
    goal.bfRunning = carriesTitles(cart, bfTitles(rules.bf));
    goal.promisable = !foreignCodes(cart, rules) && !goal.bfRunning;
    if (!projected && !goal.reached && goal.appliedSavings > 0) confirmReached(goal);
    return goal;
  }
  // What Shopify already takes off under the native titles, per title: its line
  // allocations, or its order-level application when it has no line allocation.
  function nativeSavings(cart, titles) {
    var lines = {}, total = 0;
    (Array.isArray(cart.items) ? cart.items : []).forEach(function (line) {
      (line && Array.isArray(line.line_level_discount_allocations) ? line.line_level_discount_allocations : []).forEach(function (allocation) {
        var title = allocation && allocation.discount_application && allocation.discount_application.title;
        if (titles.indexOf(title) >= 0 && money(allocation.amount)) { lines[title] = true; total += allocation.amount; }
      });
    });
    (Array.isArray(cart.cart_level_discount_applications) ? cart.cart_level_discount_applications : []).forEach(function (application) {
      if (application && titles.indexOf(application.title) >= 0 && !lines[application.title] && money(application.total_allocated_amount)) total += application.total_allocated_amount;
    });
    return money(total) ? total : null;
  }
  // Conservative estimate of Shopify's total after a hypothetical addition. Used
  // only to decide whether a suggestion really closes the shipping gap; it is
  // never displayed as a saving. Discounts round up, every known rule is assumed to
  // combine, and a saving Shopify already applies is never projected away, so the
  // estimate errs low and a free-shipping claim is never early.
  // Every discount in the cart must be one of the known native rules. A code, a
  // manual or an app discount cannot be carried onto a bigger cart exactly, so there
  // is no projection at all (null) and callers fall back to neutral copy. Every code
  // in the cart, applied or waiting for its minimum, means no projection either.
  // Removals (a box line giving way to a bigger box) are applied first, at the
  // removed units' undiscounted price; the discounts are then estimated afresh.
  function nativeProjectedTotal(cart, catalog, policy, entries, now, removals) {
    if (!cart || !money(cart.original_total_price) || !money(cart.total_price)) return null;
    var rules = policy.native, rule = sachetRule(rules), bf = bfRule(rules, cart.currency, now);
    var titles = (rule ? [rule.title] : []).concat(bf ? [bf.base.title, bf.bonus.title] : []);
    var known = nativeSavings(cart, titles);
    if (known === null || cart.original_total_price - cart.total_price !== known || hasCodes(cart)) return null;
    // A line the catalog cannot resolve may still count at Shopify; leaving it out would
    // project too little discount, so there is no projection.
    if (!Array.isArray(cart.items) || !cart.items.every(function (line) { return !!variantFor(line, catalog); })) return null;
    var next = cart;
    for (var r = 0; r < removals.length; r++) {
      next = projectRemoving(next, removals[r] && removals[r].key, removals[r] && removals[r].quantity);
      if (!next) return null;
    }
    for (var i = 0; i < entries.length; i++) {
      var variant = entries[i].variant || catalog.variants[id(entries[i].variantId)];
      next = projectAdding(next, variant, entries[i].quantity);
      if (!next) return null;
    }
    var original = next.original_total_price, live = Object.assign({}, cart, {__grigProjectionOnly:false});
    var estimate = 0;
    if (bf) {
      var tier = original >= bf.bonus.threshold || appliedSavings(live, [bf.bonus.title]) > 0;
      estimate += Math.ceil(original * (tier ? bf.bonus.percent : bf.base.percent) / 100);
    }
    if (rule && nativeCount(next, rule, catalog) >= rule.threshold) {
      var eligible = 0;
      next.items.forEach(function (line) {
        if (nativeEligible(line, rule, catalog)) eligible += originalTotal(line) || 0;
      });
      estimate += Math.ceil(eligible * rule.percent / 100);
    }
    estimate = Math.max(estimate, known);
    return Math.max(0, original - estimate);
  }
  // Flavours the shopper already has: cart lines plus the recipes of boxes in the cart.
  function seenFlavours(cart, catalog) {
    var seen = {};
    (cart && Array.isArray(cart.items) ? cart.items : []).forEach(function (line) {
      var key = id(line && (line.variant_id == null ? line.id : line.variant_id));
      if (!key || !positive(line.quantity)) return;
      seen[key] = true;
      var variant = variantFor(line, catalog);
      var box = (catalog && Array.isArray(catalog.boxes) ? catalog.boxes : []).find(function (b) { return b && b.variant && id(b.variant.id) === key; });
      var recipe = box && box.recipe || variant && variant.product && variant.product.recipe;
      if (recipe && typeof recipe === 'object') Object.keys(recipe).forEach(function (k) { if (id(k)) seen[id(k)] = true; });
      (Array.isArray(line._grigNativeComponents) ? line._grigNativeComponents : []).forEach(function (c) {
        if (c && id(c.variantId)) seen[id(c.variantId)] = true;
      });
    });
    return seen;
  }
  function nativeOpportunities(cart, catalog, policy, goal, shipping, now) {
    var result = [], counts = existingQuantities(cart), seen = seenFlavours(cart, catalog), rule = sachetRule(policy.native);
    var candidates = Object.values(catalog && catalog.variants || {}).filter(function (variant) {
      return variant && variantFor({variant_id:variant.id}, catalog) && addable(variant, 1, counts);
    }).sort(function (a, b) {
      return Number(!!seen[id(a.id)]) - Number(!!seen[id(b.id)]) || a.price - b.price || Number(a.id) - Number(b.id);
    });
    function eligibleVariant(variant) {
      return rule && rule.handles.indexOf(String(variant.product.handle || '')) >= 0 && !variant.knownBox && !variant.product.recipe &&
        !restricted(variant) && !component(variant) && !component(variant.product);
    }
    if (goal && goal.kind === 'sachets' && !goal.reached && goal.promisable && rule) {
      var sachets = candidates.filter(eligibleVariant);
      if (sachets[0]) result.push({kind:'add-sachet', variantId:id(sachets[0].id), quantity:1, price:sachets[0].price,
        gap:goal.gap, remainingAfterAdd:Math.max(0, goal.gap - 1), mode:'native'});
      // Fill the whole gap, preferring flavours the shopper does not have yet (boxes included).
      var entries = [], left = goal.gap;
      sachets.forEach(function (variant) { if (left > 0) { entries.push({variantId:id(variant.id), quantity:1, price:variant.price, unseen:!seen[id(variant.id)]}); left--; } });
      if (left > 0 && entries.length) {
        var first = entries[0], extra = catalog.variants[first.variantId];
        if (addable(extra, first.quantity + left, counts)) { first.quantity += left; left = 0; }
      }
      if (!left && entries.length) result.push({kind:'complete-sachets', entries:entries, gap:goal.gap, mode:'native',
        allUnseen:entries.every(function (e) { return e.unseen; }),
        pool:sachets.map(function (v) { return {variantId:id(v.id), price:v.price, unseen:!seen[id(v.id)]}; }),
        price:entries.reduce(function (sum, e) { return sum + e.price * e.quantity; }, 0)});
    }
    if (shipping && !shipping.reached) {
      var reaching = candidates.filter(function (variant) {
        // Counted before discounts, the cart plus the variant's list price is exact.
        var total = shipping.subtotalBasis === 'original_total_price' ? shipping.subtotal + variant.price :
          nativeProjectedTotal(cart, catalog, policy, [{variant:variant, quantity:1}], now, []);
        return total !== null && total >= shipping.threshold;
      }).sort(function (a, b) { return a.price - b.price || Number(a.id) - Number(b.id); });
      // Every candidate that provably closes the gap, cheapest first; surfaces filter further.
      result.push({kind:'shipping-gap', gap:shipping.gap, mode:shipping.mode, candidateVariantId:reaching[0] ? id(reaching[0].id) : null,
        candidates:reaching.slice(0, 24).map(function (v) { return id(v.id); }),
        price:reaching[0] ? reaching[0].price : null, requiresRecompute:false, projectedNative:true});
    }
    return result;
  }
  function opportunities(cart, catalog, goal, shipping) {
    var result = [], counts = existingQuantities(cart);
    var candidates = Object.values(catalog && catalog.variants || {}).filter(function (variant) {
      return variant && variantFor({variant_id:variant.id}, catalog) && addable(variant, 1, counts);
    }).sort(function (a, b) { return a.price - b.price || Number(a.id) - Number(b.id); });
    if (goal && goal.kind === 'sachets' && !goal.reached) {
      var sachet = candidates.find(function (variant) { return single({variant_id:variant.id, quantity:1}, catalog); });
      if (sachet) result.push({kind:'add-sachet', variantId:id(sachet.id), quantity:1, price:sachet.price,
        gap:goal.gap, remainingAfterAdd:Math.max(0, goal.gap - 1), mode:goal.mode});
    }
    [goal && goal.kind === 'bf' ? goal : null, shipping].forEach(function (target) {
      if (!target || target.reached) return;
      var reaching = candidates.filter(function (variant) { return variant.price >= target.gap; });
      // A pre-discount product price cannot prove that shipping is reached after
      // a discount. Consumers must recompute with projectAdding before claiming it.
      result.push({kind:target.kind === 'bf' ? 'bf-gap' : 'shipping-gap', gap:target.gap, mode:target.mode,
        candidateVariantId:reaching[0] ? id(reaching[0].id) : null, candidates:reaching.slice(0, 24).map(function (v) { return id(v.id); }),
        requiresRecompute:true});
    });
    return result;
  }
  function compute(cart, catalog, policy, context) {
    cart = cart || {}; catalog = catalog || {}; policy = policy || {}; context = context || {};
    var count = getSingleCount(cart, catalog), rows = rowsFor(cart, catalog);
    var currencyOK = ['EUR', 'CZK'].includes(cart.currency);
    var preview = context.mode === 'preview' && policy.preview && policy.preview.authorized === true &&
      String(context.themeId) === PREVIEW_THEME && context.themeRole === 'unpublished';
    var now = context.now == null ? Date.now() : context.now;
    var projection = {active:false, status:'native', scenario:null, percent:0, proposedLineTotals:null,
      savings:null, total:null, rounding:'line-half-up', applied:false};
    var goal = null, nativeCampaign = null;
    if (context.mode === 'preview' && !preview) projection.status = 'preview-not-authorized';
    else if (!currencyOK) projection.status = 'unsupported-currency';
    else if (preview && !rows) projection.status = 'invalid-cart';
    else if (preview) {
      projection.scenario = context.scenario;
      var percent = 0, rule;
      if (context.scenario === 'regular') {
        rule = regularPolicy(policy, cart.currency);
        projection.status = rule ? 'ready' : 'disabled';
        if (rule) {
          goal = progress('sachets', count, rule.threshold, rule.percent, 'preview');
          percent = goal.reached ? rule.percent : 0;
        }
      } else if (context.scenario === 'bf') {
        rule = policy.bf;
        projection.status = bfStatus(rule, cart.currency, now);
        if (projection.status === 'ready') {
          goal = progress('bf', cart.original_total_price, rule.threshold, rule.bonusPercent, 'preview');
          percent = goal.reached ? rule.bonusPercent : rule.basePercent;
        }
      } else projection.status = 'invalid-scenario';
      if (projection.status === 'ready') {
        projection.active = true; projection.percent = percent; projection.total = 0;
        projection.proposedLineTotals = rows.map(function (row) {
          var appliedPercent = context.scenario === 'bf' || row.eligible ? percent : 0;
          var total = roundLine(row.originalLineTotal, appliedPercent);
          projection.total += total;
          return Object.assign({}, row, {proposedLineTotal:total, savings:row.originalLineTotal - total, percent:appliedPercent});
        });
        projection.savings = cart.original_total_price - projection.total;
      }
    }
    var native = !preview && currencyOK && nativeActive(policy);
    if (native) {
      goal = nativeGoal(cart, catalog, policy, now);
      var rule = sachetRule(policy.native);
      if (rule) count = nativeCount(cart, rule, catalog);
    } else if (!preview && currencyOK && !cart.__grigProjectionOnly && merch && merch.campaignState) {
      nativeCampaign = merch.campaignState(cart, policy.nativeCampaign, now);
      if (nativeCampaign) goal = Object.assign(progress('bf', nativeCampaign.subtotal, nativeCampaign.threshold,
        nativeCampaign.percent, 'native-verified'), {actualSavings:nativeCampaign.actualSavings});
    }
    var shipping = currencyOK && !cart.__grigProjectionOnly ? shippingState(cart, policy, projection, preview) :
      currencyOK && preview && projection.active ? shippingState(cart, policy, projection, preview) : null;
    return {native:cart.__grigProjectionOnly ? null : clone(cart), currency:cart.currency || null, mode:native ? 'native' : preview ? 'preview' : 'plain',
      eligibleSachetCount:count, subtotal:money(cart.original_total_price) ? cart.original_total_price : null,
      projection:projection, nextGoal:goal, shipping:shipping, nativeCampaign:nativeCampaign,
      opportunities:native ? nativeOpportunities(cart, catalog, policy, goal, shipping, now) : opportunities(cart, catalog, goal, shipping)};
  }
  function projectAdding(cart, variant, quantity) {
    if (!cart || !Array.isArray(cart.items) || !money(cart.original_total_price) || !money(cart.total_price) ||
        !addable(variant, quantity, existingQuantities(cart))) return null;
    var amount = variant.price * quantity;
    if (!money(amount) || !money(cart.original_total_price + amount) || !money(cart.total_price + amount)) return null;
    var next = clone(cart), key = 'grig-model:' + id(variant.id) + ':' + next.items.length;
    next.items.push({key:key, id:variant.id, variant_id:variant.id, product_id:variant.product.id, handle:variant.product.handle,
      quantity:quantity, price:variant.price, original_price:variant.price, final_price:variant.price,
      original_line_price:amount, line_price:amount, final_line_price:amount,
      knownBox:variant.knownBox === true, has_components:variant.has_components === true,
      requires_components:variant.requires_components === true, properties:{}, line_level_discount_allocations:[], grigModel:true});
    next.original_total_price += amount; next.total_price += amount;
    next.item_count = next.items.reduce(function (sum, line) { return sum + (positive(line.quantity) ? line.quantity : 0); }, 0);
    next.__grigProjectionOnly = true;
    return next;
  }
  // A cart with `quantity` units of one line (by key) taken out, for projections
  // only: the units leave at their undiscounted price and the line keeps no
  // allocation, since every native discount is estimated again afterwards.
  function projectRemoving(cart, key, quantity) {
    if (!cart || !Array.isArray(cart.items) || key == null || !positive(quantity) ||
        !money(cart.original_total_price) || !money(cart.total_price)) return null;
    var index = -1;
    cart.items.forEach(function (line, i) { if (line && line.key != null && String(line.key) === String(key)) index = index === -1 ? i : -2; });
    var line = index >= 0 ? cart.items[index] : null, total = line ? originalTotal(line) : null;
    if (!line || !positive(line.quantity) || quantity > line.quantity || total === null || total % line.quantity !== 0) return null;
    var amount = total / line.quantity * quantity;
    if (amount > cart.original_total_price) return null;
    var next = clone(cart);
    if (quantity === line.quantity) next.items.splice(index, 1);
    else {
      var rest = next.items[index], left = total - amount;
      rest.quantity -= quantity; rest.original_line_price = left; rest.line_price = left; rest.final_line_price = left;
      rest.line_level_discount_allocations = [];
    }
    next.original_total_price -= amount; next.total_price = Math.max(0, next.total_price - amount);
    next.item_count = next.items.reduce(function (sum, item) { return sum + (positive(item.quantity) ? item.quantity : 0); }, 0);
    next.__grigProjectionOnly = true;
    return next;
  }
  function projectNativeTotal(cart, catalog, policy, entries, now, removals) {
    if (!cart || !catalog || !nativeActive(policy) || !Array.isArray(entries) || (removals != null && !Array.isArray(removals))) return null;
    return nativeProjectedTotal(cart, catalog, policy, entries, now == null ? Date.now() : now, removals || []);
  }
  // A goal counts as reached for analytics only when its claim stands: a native discount
  // tier only when Shopify allocates it (the Black Friday bonus under its own title, the
  // sachet rule under its title), never by the total or the count alone.
  function claimReached(goal) {
    if (goal.mode === 'native' && goal.kind === 'bf') return goal.tierConfirmed === true;
    if (goal.mode === 'native' && goal.kind === 'sachets') return goal.appliedSavings > 0;
    return goal.reached === true;
  }
  // Analytics: the goals whose reached state changed between two settled quotes of the
  // same currency and scenario, as goal_reached / goal_lost.
  function goalTransitions(before, after) {
    if (!before || !after || before.currency !== after.currency || before.projection.scenario !== after.projection.scenario ||
        before.projection.active !== after.projection.active) return [];
    var result = [];
    [after.nextGoal, after.shipping].forEach(function (goal) {
      if (!goal) return;
      var previous = [before.nextGoal, before.shipping].find(function (g) { return g && g.kind === goal.kind; });
      if (!previous || previous.mode !== goal.mode || previous.target !== goal.target || claimReached(previous) === claimReached(goal)) return;
      result.push({event:claimReached(goal) ? 'goal_reached' : 'goal_lost', goal:goal});
    });
    return result;
  }
  return {compute:compute, getSingleCount:getSingleCount, projectAdding:projectAdding,
    appliedSavings:appliedSavings, projectNativeTotal:projectNativeTotal, goalTransitions:goalTransitions,
    offerMode:offerMode, pageOfferMode:pageOfferMode, bfDates:bfDates, bfSchedule:bfSchedule};
});
